// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgi_a bho_vt bho_ea bho_a","MenuItem__Btn":"bgi_b bho_z","MenuItem__subtitle":"bgi_c"};